export default function Stats({ items }) {
  if (!items.length)
    return (
      <p className="stats">
        <em>Füge deine benötigten Sachen ein</em>
      </p>
    );
  const numItems = items.length;
  const numPacked = items.filter((item) => item.packed).length;
  const percentage = Math.round((numPacked / numItems) * 100);
  return (
    <footer className="stats">
      <em>
        {percentage === 100
          ? "Du hast alles zusammen! Ready to go"
          : `📉 Du hast ${numItems} Gegenstände in deiner Liste, du hast schon
        ${numPacked} Gegenstände gepackt (${percentage}%)`}
      </em>
    </footer>
  );
}
